module.exports = __webpack_public_path__ + "img/jf.4ac9a04b.png";